import { Button, Typography, Divider, Grid } from "@material-ui/core";
import { PieceCard } from "../../components/PieceCard";
import { Spacer } from "../../components/Spacer";

export const Home = () => {
    return (
        <div>
            <Spacer size={50} />
            <Typography variant='h4'>
                WHO AM I?
            </Typography>
            <Spacer size={30} />
            <div>
                <Typography>
                    こんにちは。ナラクタです。<br />
                    本サイトは私が関わった創作物を公開可能な範囲でまとめています。<br />
                    あなたの楽しみが多からんことを願って。
                </Typography>
            </div>
        </div>
    )
};
